import { NavLink } from 'react-router-dom';

import style from './Menu.module.css';

import { Text } from '../../../Text';

type MenuProps = {
  label: string;
  menuItems: { label: string; to: string }[];
};

export function Menu({ label, menuItems }: MenuProps) {
  return (
    <div role="menu" aria-label={label} className={style.menu}>
      {menuItems.map(menuItem => {
        return (
          <div role="menuitem" key={menuItem.label}>
            <Text asChild color="Kale2" variant="heading-16" bold>
              <NavLink to={menuItem.to} activeClassName={style.active}>
                {menuItem.label}
              </NavLink>
            </Text>
          </div>
        );
      })}
    </div>
  );
}
